import { Box } from '@chakra-ui/react';
import { SWRConfig } from 'swr';
import SchoolSidebar from 'layout/School/sidebar/SideBar';
import { Outlet } from 'react-router-dom';
import SchoolHeader from './Header';
import ErrorBoundaryClass from 'components/ErrorBoundary';

function SchoolLayout() {
  return (
    <>
      <ErrorBoundaryClass>
        <SWRConfig value={{ provider: () => new Map() }}>
          <Box>
            <SchoolHeader />
            <SchoolSidebar>
              <Box padding="20px">
                <Outlet />
              </Box>
            </SchoolSidebar>
          </Box>
        </SWRConfig>
      </ErrorBoundaryClass>
    </>
  );
}

export default SchoolLayout;
